import React from 'react';
import './HeroSection.css';
import { useNavigate } from 'react-router-dom';

const HeroSection: React.FC = () => {
    const navigate = useNavigate();
    const onClick = () => {
        navigate("/book-now")
    }
    return (
        <div className="hero">
            <p>Care and Shine, Right at Your Door.</p>
            <h2>Your Mobile Car Detailing Experts!</h2>
            <button className="cta-button" onClick={onClick}>Book Now</button>
        </div>
    )
}

export default HeroSection;
